import styled from 'styled-components';

const SubscriptionForkWrapper = styled.div`
  width: 100%;
`;

export { SubscriptionForkWrapper };
